import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import 'symbol-observable';
// import { createStore,applyMiddleware } from 'redux';
import { configureStore } from '@reduxjs/toolkit'

// import thunk from 'redux-thunk';
// import rootReducer from './reducers'; // Assuming you have a rootReducer
import studentsReducer from './reducers/studentsReducer'; 
import subjectsReducer from './reducers/subjectsReducer'; 
import subjectInstancesReducer from './reducers/subjectInstancesReducer'; 
import enrollmentsReducer from './reducers/enrollmentsReducer'; 
import assignmentsReducer from './reducers/assignmentsReducer'; 
import gradesReducer from './reducers/gradesReducer'; 
import attendancesReducer from './reducers/attendancesReducer'; 
import selectionReducer from './reducers/selectionReducer'; 
import paymentRecordsReducer from './reducers/paymentRecordsReducer'; 
import tuitionValuesReducer from './reducers/tuitionValuesReducer'; 
import loadingReducer from './reducers/loadingReducer';

import App from './App';

// const store = createStore(rootReducer, applyMiddleware(thunk));
const store = configureStore({
  reducer: {
    students: studentsReducer,
    subjects: subjectsReducer,
    subjectInstances: subjectInstancesReducer,
    enrollments: enrollmentsReducer,
    assignments: assignmentsReducer,
    grades: gradesReducer,
    attendances: attendancesReducer,
    paymentRecords: paymentRecordsReducer,
    selection:  selectionReducer,
    tuitionValues:  tuitionValuesReducer,
    loading: loadingReducer,
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <Provider store={store}>
    <App />
    </Provider>
  // </React.StrictMode>
);
